"use client";

import { IconNotFound } from "@repo/assets/images";
import { Button } from "@repo/ui";
import BasicHeader from "../BasicHeader";
function GlobalErrorComponent() {
  const locale = window.location.pathname?.split("/")?.[1];
  const isArabic = locale === "ar";
  return <html dir={isArabic ? "rtl" : "ltr"} lang={locale} data-sentry-component="GlobalErrorComponent" data-sentry-source-file="GlobalErrorComponent.jsx">
      {/* eslint-disable-next-line @next/next/no-head-element */}
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" data-sentry-element="meta" data-sentry-source-file="GlobalErrorComponent.jsx" />
        <link href="https://fonts.cdnfonts.com/css/somar-sans" rel="stylesheet" />
        <link href="https://fonts.cdnfonts.com/css/barlow" rel="stylesheet" />
        <link href="https://fonts.cdnfonts.com/css/playfair-display" rel="stylesheet" />
      </head>
      <body style={{
      margin: "0",
      marginInline: "auto",
      display: "flex",
      flexDirection: "column",
      width: "100vw",
      height: "100vh",
      padding: "0",
      overflow: "hidden",
      background: "#FFFFFF",
      fontFamily: "somar, barlow, playFair",
      alignItems: "center"
    }}>
        <BasicHeader isArabic={isArabic} data-sentry-element="BasicHeader" data-sentry-source-file="GlobalErrorComponent.jsx" />
        <main style={{
        width: "100%",
        padding: "0 1rem"
      }}>
          <div style={{
          position: "relative",
          top: 0,
          height: "66px",
          width: "100%"
        }}></div>
          <div style={{
          marginInline: "auto",
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1.5rem",
          textAlign: "center"
        }}>
            <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "9999px",
            background: "#F5F2EE",
            // supportiveYellow
            padding: "2.5rem"
          }}>
              <IconNotFound style={{
              display: "block",
              margin: "0 auto",
              width: "6rem",
              height: "6rem",
              color: "#e5a855"
            }} data-sentry-element="IconNotFound" data-sentry-source-file="GlobalErrorComponent.jsx" />
            </div>
            <h3 style={{
            fontSize: "2.25rem",
            fontWeight: "500",
            color: "#1B1B1B",
            // supportiveBlack
            lineHeight: "100%",
            letterSpacing: "0%",
            textAlign: "center",
            verticalAlign: "middle",
            padding: 0,
            margin: 0
          }}>
              {isArabic ? "عفواً، لم يظهر شيء" : "Oops, nothing showed up"}
            </h3>
            <p style={{
            display: "flex",
            flexDirection: "column",
            fontSize: "1rem",
            color: "#1B1B1B",
            // supportiveBlack
            fontFamily: "Barlow",
            fontWeight: 500,
            lineHeight: "1.5rem",
            letterSpacing: "0%",
            textAlign: "center",
            verticalAlign: "middle",
            margin: 0,
            padding: 0
          }}>
              <span>
                {isArabic ? "حدث خطأ ما أثناء التحميل." : "Something went wrong while loading."}
              </span>
              <span>
                {isArabic ? 'يرجى الضغط على "تحديث" لمحاولة مرة أخرى.' : "Please hit refresh to try again."}
              </span>
            </p>

            <Button variant="primary" style={{
            fontSize: "1rem",
            padding: "0.5rem 1rem",
            minWidth: "80px",
            background: "#e5a855",
            color: "#1B1B1B",
            border: "none",
            cursor: "pointer"
          }} size="sm" onClick={() => window.location.reload()} type="button" data-sentry-element="Button" data-sentry-source-file="GlobalErrorComponent.jsx">
              {isArabic ? "ينعش" : "Refresh"}
            </Button>
          </div>
        </main>
      </body>
    </html>;
}
export default GlobalErrorComponent;